import eventBus from './eventBus';
import { get, postForm } from './Utilities/fetchUtilities';
import { getBaseMemberData } from "./member";

const loginEvent = "loginSuccess",
    logoutEvent = "logoutSuccess",
    loginUrl = "/api/CorpLogin",
    logoutUrl = "/Member/Logout",
    bodyClassName = "logged-in";

export function login(email: string, password: string, host: string = "", dispatchEvent: boolean = true): Promise<{ valid: boolean, reset: boolean }> {
    return postForm(host + loginUrl, { un:email, pw:password }).then(response => {
        if (response.ok) {
            return response.json();
        }
        throw "An error occurred.";
    }).then(obj => {
        if(obj && obj.corpPersonResponse) {
            if(obj.corpPersonResponse.valid) {
                if(dispatchEvent) {
                    setTimeout(() => dispatchLoginEvent(), 10);
                }
                setTimeout(() => getBaseMemberData(false, host), 100);
                document.body.classList.add(bodyClassName);
            }
            return {
                valid: obj.corpPersonResponse.valid,
                reset: obj.corpPersonResponse.forcePasswordReset
            }
        }
    });
}

export function logout(host: string): Promise<boolean> {
    return get(host + logoutUrl, true)
        .then(x => {         
            deleteCookies();
            document.body.classList.remove(bodyClassName);
            dispatchLogoutEvent();          
            return true;
        })
        .catch(x => false);
}

function deleteCookies() {
    var allCookies = document.cookie.split(';');
    
    for (var i = 0; i < allCookies.length; i++)
        document.cookie = allCookies[i] + "=;expires="
        + new Date(0).toUTCString();
}

export function attachToLoginEvent(func: EventListenerOrEventListenerObject): void {
    eventBus.attach(loginEvent, func);
}

export function detachFromLoginEvent(func: EventListenerOrEventListenerObject): void {
    eventBus.detach(loginEvent, func);
}

export function dispatchLoginEvent(detail: any = null): void {
    eventBus.dispatch(loginEvent, detail);
}

export function attachToLogoutEvent(func: EventListenerOrEventListenerObject): void {
    eventBus.attach(logoutEvent, func);
}

export function detachFromLogoutEvent(func: EventListenerOrEventListenerObject): void {
    eventBus.detach(logoutEvent, func);
}

export function dispatchLogoutEvent(detail: any = null) {
    eventBus.dispatch(logoutEvent, detail);
}